import { useTranslation } from "next-i18next";
import { useContext } from "react";

import { Header } from "@baseComponents/Header";
import { CTA } from "@components/CTA";
import { BlogContext } from "@context/BlogContext";
import { portfolioArticleCards } from "@portfolios";

import { BlogLayout } from "./BlogLayout";
import {
  StyledArticlesMainLayout,
  StyledArticlesSeeAlso,
} from "./styles.styled";

export default function MDXPagePL() {
  const blogContext = useContext(BlogContext);
  const { t } = useTranslation();

  return (
    <BlogLayout
      title="O UX, kodzie i naszej pracy zespołowej"
      description="Poznaj nasz sposób pracy, ulubione technologie oraz najnowsze trendy w projektowaniu UX/UI. Na blogu dzielimy się wiedzą, inspiracjami i doświadczeniami z zakresu tworzenia oprogramowania i designu produktów cyfrowych."
    >
      <Header
        header="Blog"
        subheader="Dowiedz się więcej o tym jak pracujemy, z jakich rozwiązań lubimy korzystać oraz o aktualnych rozwiązaniach ze świata UX/UI."
      />

      <StyledArticlesMainLayout
        articles={blogContext.getSortedArticleCards()}
      />

      <StyledArticlesSeeAlso
        articles={portfolioArticleCards.map(({ pl }) => pl)}
        sectionHeader={t("blog_page.see_also_header")}
        sectionSubheader={t("blog_page.see_also_subheader")}
      />

      <CTA
        buttonText="Darmowa Konsultacja"
        header="Porozmawiajmy o Twoim projekcie."
        subheader="Skorzystaj z bezpłatnej konsultacji i przekonaj się jak możemy wcielić Twoje pomysły w życie."
      />
    </BlogLayout>
  );
}
